<template>
  <layout-sub-modulo>
    <template v-slot:title>
      {{ estaEditando ? 'Editar' : 'Registrar' }} Empresa
    </template>
    <template v-slot:body>
      <v-container class="px-12 w-full">
        <v-form ref="formularioRef">
          <v-card-title class="pb-0">Datos Generales</v-card-title>
          <v-divider class="pb-5"></v-divider>

          <v-row class="mx-1">
            <v-col cols="12" md="3">
              <v-text-field
                label="Identificación *"
                outlined
                dense
                autocomplete="off"
                :disabled="estaEditando"
                v-model="nit"
                :rules="[
                  validacion.required,
                  validacion.nitLongitud,
                  validacion.soloNumeros,
                ]"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                label="Razón social *"
                outlined
                dense
                autocomplete="off"
                v-model="razonSocial"
                :rules="[validacion.required, validacion.razonSocial]"
              />
            </v-col>

            <v-col cols="12" md="2"></v-col>

            <v-col cols="12" md="2" class="d-flex justify-end align-center">
              <v-checkbox
                v-model="tieneConvenio"
                label="¿Maneja convenio?"
                class="ma-0 pa-0"
              />
            </v-col>
          </v-row>

          <v-card-title class="pt-0">Asignación de Sucursales</v-card-title>
          <v-card-subtitle class="pb-1 grey--text text--darken-1 font-italic"
            >Adicione al menos una sucursal para asociar a la empresa.
            <span class="red--text">*</span></v-card-subtitle
          >
          <v-btn
            class="ma-2 ml-4 white-text text-capitalize"
            color="primary"
            @click="abrirModalSucursal"
          >
            Adicionar sucursal
          </v-btn>
          <v-divider class="pb-5"></v-divider>
          <table-sucursales
            :listadoSucursales="listadoSucursales"
            :nit="nit"
            :estaEditando="estaEditando"
            @editar-sucursal="abrirModalEditarSucursal"
            @eliminar-sucursal="eliminarSucursal"
          ></table-sucursales>
          <sucursales-modal
            :dialog="dialogSucursal"
            :editando="editandoSucursal"
            :sucursal="sucursalEditando"
            @close="cerrarModalSucursal"
            @guardar="agregarSucursal"
          />

          <v-card-title class="mt-7">Logo</v-card-title>
          <v-card-subtitle class="pb-1 grey--text text--darken-1 font-italic">
            El formato de la imagen debe ser "PNG"
          </v-card-subtitle>
          <v-divider class="pb-5"></v-divider>
          <v-row class="d-flex justify-center">
            <v-col cols="12" md="6">
              <image-uploader
                v-model="logoFile"
                :nombre-logo="nombreLogo"
                @change="cargarLogo"
                @mostrar-error="mostrarError"
              />
            </v-col>
          </v-row>
          <div class="d-flex justify-center">
            <router-link :to="{ name: 'parametrizacionempresa' }">
              <v-btn class="mt-4 white--text" color="error "> Cancelar </v-btn>
            </router-link>
            <v-btn
              class="mt-4 ml-4 white--text"
              color="primary"
              @click="
                estaEditando ? actualizarEmpresa(empresa) : crearEmpresa()
              "
            >
              {{ estaEditando ? 'Actualizar' : 'Guardar' }}
            </v-btn>
          </div>
        </v-form>
      </v-container>
    </template>
  </layout-sub-modulo>
</template>

<script>
import swal2 from 'sweetalert2';

import { alertWarningConfirmar } from '../../../plugins/sweetalert2';
import TableSucursales from './Table/SucursalesTable.vue';
import LayoutSubModulo from '../../../components/Layout/SubModulo.vue';
import ImageUploader from '../../../components/ImagenCompania.vue';
import SucursalesModal from './Modal/SucursalesModal.vue';
import empresaService from '../../../Services/empresaService';
import apiDocumentosService from '../../../Services/apiDocumentosService';
import empleadoService from '../../../Services/empleadoService';
import { alertInfo, alertWarning } from '../../../utils/alertUtil';

export default {
  name: 'EditarEmpresa',

  props: {
    estaEditando: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    TableSucursales,
    LayoutSubModulo,
    ImageUploader,
    SucursalesModal,
  },
  data() {
    return {
      nit: '',
      razonSocial: '',
      empresa: '',
      nombreEmpresa: '',
      logoFile: null,
      nombreLogo: '',
      empresas: [],
      tieneConvenio: false,
      sucursalesSeleccionadas: [],
      sucursalesExistentes: [],
      listadoSucursales: {
        data: [],
        loading: false,
      },
      validacion: {
        required: value => !!value || 'Este campo es obligatorio',

        nitLongitud: value =>
          (value ? value.length >= 6 && value.length <= 15 : true) ||
          'La identificación debe tener entre 6 y 15 caracteres',

        soloNumeros: value =>
          (value ? /^[0-9]+$/.test(value) : true) ||
          'El NIT solo puede contener números',

        razonSocial: value =>
          (value ? value.length <= 100 : true) ||
          'La razón social no debe exceder los 100 caracteres',
      },
      dialogSucursal: false,
      editandoSucursal: false,
      sucursalEditando: null,
    };
  },

  mounted() {
    this.cargarDatosIniciales();
  },

  methods: {
    abrirModalSucursal() {
      this.editandoSucursal = false;
      this.sucursalEditando = null;
      this.dialogSucursal = true;
    },

    cerrarModalSucursal() {
      this.dialogSucursal = false;
      this.editandoSucursal = false;
      this.sucursalEditando = null;
    },

    cargarDatosIniciales() {
      if (!this.estaEditando) {
        return;
      }
      this.empresa = this.$route.params.nit.toString();
      this.cargarSucursalesExistentes();
      this.listarSucursales();
    },

    async cargarSucursalesExistentes() {
      const empresa = await empresaService.buscarTodos({ nit: this.empresa });
      const empresaExistente = empresa.data?.[0] ?? null;

      if (!empresaExistente) {
        this.limpiarSucursales();
        return;
      }

      this.mapearDatosEmpresa(empresaExistente);
    },

    limpiarSucursales() {
      this.sucursalesExistentes = [];
      this.sucursalesSeleccionadas = [];
      this.listadoSucursales.data = [];
    },

    mapearDatosEmpresa(empresa) {
      const sucursales = empresa.sucursales ?? [];

      this.sucursalesExistentes = sucursales;
      this.sucursalesSeleccionadas = sucursales.map(sucursal => ({
        ...sucursal,
      }));
      this.listadoSucursales.data = sucursales.map(sucursal => ({
        sucursal_id: sucursal.sucursal_id,
        descripcion_sucursal: sucursal.descripcion_sucursal,
      }));

      this.tieneConvenio = empresa.tiene_convenio;
      this.nombreLogo = empresa.url_logo ?? '';
      this.nit = empresa.nit.toString();
      this.razonSocial = empresa.razon_social;
    },

    async listarSucursales() {
      if (!this.empresa || this.empresa === '') {
        this.limpiarDatos();
        return;
      }

      if (!this.estaEditando) {
        const filtros = { nit: this.empresa };
        const buscarEmpresaPorNit = await empresaService.buscarTodos(filtros);
        const empresaExistente = buscarEmpresaPorNit.data?.[0] || null;

        if (empresaExistente) {
          alertInfo('La empresa ya existe, por favor seleccione otra.');
          this.empresa = '';
          return;
        }
        this.sucursalesExistentes = [];
      }

      this.limpiarDatos();
    },

    async crearEmpresa() {
      const formulario = this.$refs.formularioRef;
      if (!formulario.validate()) {
        return;
      }
      if (this.sucursalesSeleccionadas.length === 0) {
        alertInfo(
          'Debe crear al menos una sucursal para asociar a la empresa.'
        );
        return;
      }
      const datosEmpresa = {
        nit: Number(this.nit),
        razon_social: this.razonSocial,
        sucursales: this.prepararSucursales(this.sucursalesSeleccionadas),
        tiene_convenio: this.tieneConvenio,
      };
      if (this.logoFile) {
        datosEmpresa.url_logo = await this.guardarNuevoLogo();
      }
      await empresaService.crear(datosEmpresa);
      this.$router.push({ name: 'parametrizacionempresa' });
    },

    abrirModalEditarSucursal(sucursal) {
      this.editandoSucursal = true;
      this.sucursalEditando = { ...sucursal };
      this.dialogSucursal = true;
    },

    agregarSucursal(sucursal) {
      if (this.editandoSucursal) {
        const nuevasSucursales = this.sucursalesSeleccionadas.map(sucursales =>
          sucursales.sucursal_id === this.sucursalEditando.sucursal_id
            ? { ...sucursales, ...sucursal }
            : sucursales
        );

        this.sucursalesSeleccionadas = nuevasSucursales;
        this.actualizarListadoTabla(nuevasSucursales);

        alertInfo(
          'Los cambios de la sucursal se aplicarán al guardar la empresa.'
        );

        this.cerrarModalSucursal();
        return;
      }

      const existe = this.sucursalesSeleccionadas.some(
        s => s.sucursal_id === sucursal.sucursal_id
      );

      if (existe) {
        alertInfo('Ya existe una sucursal con ese código.');
        return;
      }

      this.sucursalesSeleccionadas = [
        ...this.sucursalesSeleccionadas,
        sucursal,
      ];

      this.actualizarListadoTabla(this.sucursalesSeleccionadas);
      this.cerrarModalSucursal();
    },

    actualizarListadoTabla(sucursales) {
      this.listadoSucursales.data = sucursales.map(sucursal => ({
        sucursal_id: sucursal.sucursal_id,
        descripcion_sucursal: sucursal.descripcion_sucursal,
      }));
    },

    limpiarObjeto(obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([_, value]) =>
            value !== null &&
            value !== undefined &&
            !(typeof value === 'number' && Number.isNaN(value))
        )
      );
    },

    prepararSucursales(sucursales) {
      return sucursales.map(sucursal => this.limpiarObjeto(sucursal));
    },

    eliminarSucursalEstado(idSucursal) {
      this.sucursalesSeleccionadas = this.sucursalesSeleccionadas.filter(
        sucursal => sucursal.sucursal_id !== idSucursal
      );

      this.actualizarListadoTabla(this.sucursalesSeleccionadas);
    },

    async eliminarSucursal(idSucursal, nombreSucursal) {
      if (!this.estaEditando) {
        this.eliminarSucursalEstado(idSucursal);
        return;
      }
      const confirmacion = await alertWarningConfirmar(
        `¿Está seguro de eliminar la sucursal ${idSucursal} - ${nombreSucursal}?`
      );
      if (!confirmacion.isConfirmed) {
        return;
      }
      const resultado = await empleadoService.verificarPorSucursal(
        this.nit,
        idSucursal
      );
      if (resultado?.tieneEmpleados) {
        alertWarning(
          'No se puede eliminar la sucursal porque tiene empleados vinculados.'
        );
        return;
      }
      alertInfo(
        'La sucursal será eliminada al guardar los cambios de la empresa.'
      );
      this.eliminarSucursalEstado(idSucursal);
    },

    async actualizarEmpresa(nit) {
      const formulario = this.$refs.formularioRef;
      if (!formulario.validate()) {
        return;
      }

      if (this.sucursalesSeleccionadas.length === 0) {
        alertInfo(
          'Debe seleccionar al menos una sucursal para asociar a la empresa.'
        );
        return;
      }

      const urlLogo = this.nombreLogo
        ? await this.actualizarLogo()
        : await this.guardarNuevoLogo();

      const empresaActualizada = {
        razon_social: this.razonSocial,
        sucursales: this.prepararSucursales(this.sucursalesSeleccionadas),
        tiene_convenio: this.tieneConvenio,
      };

      if (urlLogo) {
        empresaActualizada.url_logo = urlLogo;
      }

      await empresaService.actualizarPorNit(nit, empresaActualizada);
      this.$router.push({ name: 'parametrizacionempresa' });
    },

    async guardarNuevoLogo() {
      if (!this.logoFile || typeof this.logoFile === 'string') {
        return null;
      }

      const formData = new FormData();
      formData.append('file', this.logoFile);

      const response = await apiDocumentosService.guardarArchivo('Logo', formData);
      return response.img;
    },

    async actualizarLogo() {
      if (!this.logoFile) {
        return this.nombreLogo;
      }

      if (typeof this.logoFile === 'string') {
        return this.logoFile;
      }

      const formData = new FormData();
      formData.append('file', this.logoFile);

      const response = await apiDocumentosService.actualizarArchivo(
        'Logo',
        this.nombreLogo,
        formData
      );
      return response.img;
    },

    cargarLogo(logoCompania) {
      if (!logoCompania) {
        this.logoFile = null;
        return;
      }
      this.logoFile = logoCompania;
    },

    mostrarError(mensaje) {
      swal2.fire({
        title: '¡Incorrecto!',
        html: `<span style='font-family:Roboto;'>${mensaje}</span>`,
        icon: 'error',
        timer: 5000,
      });
    },

    async limpiarDatos() {
      this.sucursalesSeleccionadas = [];
      this.sucursalesExistentes = [];
      this.listadoSucursales.data = [];
      this.listadoSucursales.loading = false;
      this.logoFile = null;
      this.nombreLogo = '';
    },
  },
};
</script>

<style scoped></style>
